import styled from 'styled-components';
import colors from 'constants/colors';

export const Content = styled.div`
  width: 100%;

  .couponDescription {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.5px;
    color: ${colors.silver};
  }

  .noCoupon {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.5px;
    color: ${colors.silver};
    text-align: center;
    margin: 32px 0;
  }
`;

export const CouponTableContainer = styled.table`
  width: 100%;
  color: ${colors.white};
  border-collapse: collapse;
  font-size: 14px;
  margin-top: 32px;
  background-color: ${colors.black2};

  th {
    height: 20px;
    vertical-align: bottom;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 1px;
    padding-bottom: 8px;
    border-bottom: 1px solid ${colors.darkGrey};
    color: ${colors.silver};
  }

  td {
    height: 42px;
    padding: 16px 0;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.5px;
    color: ${colors.white};
    border-bottom: 1px solid ${colors.darkGrey};

    .slider {
      position: relative;
    }

    .actions{
      display: flex;
      justify-content: flex-start;
      align-items: center;
      column-gap: 16px;

      .edit {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.5px;
        cursor: pointer;
        text-decoration: underline;
        svg {
          height: 14px;
        }
      }

      .delete {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.5px;
        color: ${colors.red};
        cursor: pointer;
        text-decoration: underline;
        svg {
          height: 14px;
          filter: invert(53%) sepia(97%) saturate(6447%) hue-rotate(330deg) brightness(103%) contrast(105%);
        }
      }
    }
  }

  .couponCode {
    width: 20%;
  }

  .discount {
    width: 15%;
  }

  .startDate {
    width: 18%;
  }

  .endDate {
    width: 18%;
  }

  .onOff {
    width: 10%;
    position: relative;
  }

  .action {
    width: 136px;
  }
`;
